import { useMutation } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

interface DeletePracticeSetRequest {
  practiceSetId: string;
}

const useDeletePracticeSet = () => {
  return useMutation({
    mutationFn: async ({ practiceSetId }: DeletePracticeSetRequest): Promise<void> => {
      const {
        data: { session },
      } = await supabaseClient.auth.getSession();

      if (!session) {
        throw new Error('Not authenticated');
      }

      // Delete practice set (cascade will delete practice_answers)
      const { error } = await supabaseClient
        .from('practice_attempts')
        .delete()
        .eq('id', practiceSetId)
        .eq('auth_id', session.user.id); // Ensure user can only delete their own sets

      if (error) {
        throw new Error(error.message || 'Failed to delete practice set');
      }
    },
  });
};

export default useDeletePracticeSet;
